import type { ReactNode } from 'react';
import React from 'react';
import { Box, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import type { LucideIcon } from 'lucide-react';

export interface IEmptyStateProps {
  icon: LucideIcon;
  title: string;
  subtitle: string;
  action?: ReactNode;
}

export const EmptyState = ({ icon: Icon, title, subtitle, action }: IEmptyStateProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        py: 10,
        textAlign: 'center',
      }}
    >
      <Box
        sx={{
          width: 64,
          height: 64,
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          mb: 2,
          bgcolor: (theme) => alpha(theme.palette.success.main, 0.1),
          color: 'success.main',
        }}
      >
        <Icon size={32} />
      </Box>
      <Typography variant="h3" sx={{ color: 'text.primary', fontWeight: 600 }}>
        {title}
      </Typography>
      <Typography variant="body2" sx={{ color: 'text.secondary', mt: 0.5, maxWidth: 360 }}>
        {subtitle}
      </Typography>
      {action && <Box sx={{ mt: 2.5 }}>{action}</Box>}
    </Box>
  );
};
